import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    EntityCustomFieldValueView,
    EntityTypeCustomFieldClient,
    EntityTypeCustomFieldView,
    SearchEntityTypeCustomFieldParameters
} from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class EntityTypeCustomFieldService {
    constructor(private readonly client: EntityTypeCustomFieldClient) {}

    async search(body: SearchEntityTypeCustomFieldParameters): Promise<EntityTypeCustomFieldView[]> {
        return await lastValueFrom(this.client.entityTypeCustomFieldSearch(body));
    }

    async save(body: EntityTypeCustomFieldView[]): Promise<EntityTypeCustomFieldView[]> {
        return await lastValueFrom(this.client.entityTypeCustomFieldSave(body));
    }

    async getCustomFieldsByEntityType(entityTypeId: number): Promise<EntityCustomFieldValueView[]> {
        return await lastValueFrom(this.client.entityTypeCustomFieldGetCustomFieldsByEntityType(entityTypeId));
    }

    async activate(id: number): Promise<void> {
        return await lastValueFrom(this.client.entityTypeCustomFieldActivate(id));
    }

    async deactivate(id: number): Promise<void> {
        return await lastValueFrom(this.client.entityTypeCustomFieldDeactivate(id));
    }
}
